﻿window.lstAjaxRequest = [];
window.lstAjaxRequestAbort = [];
window._lastDateRequestAjax = new Date();
window.idxExe = 0
window.lstAjaxRequestReconnexion = []
window.cAjaxRequest = function (dataToBeSent, bddForAjax, funcOk, funcAlways, funcKo, showErreur) {
    var Me = this;
    lstAjaxRequest.push(this)
    this.dataToBeSent = JSON.clone(dataToBeSent)
    mMigreDateCodeToNet(this.dataToBeSent);
    mMigreDateToNet(this.dataToBeSent)
    var stacktrace = mGetStackTrace();
    this.dataToBeSent.idxpage = _idxPage

    this.mGetFuncAlways = function () { return funcAlways }
    this.mSetFuncAlways = function (func) { funcAlways=func }

    var async = ((typeof this.dataToBeSent.async == 'undefined') ? true : this.dataToBeSent.async);
    if (typeof this.dataToBeSent.async != 'undefined') delete this.dataToBeSent.async;

    this.execute = function () {

        var urlCall = dataToBeSent.urlAjax
        _lastDateRequestAjax = new Date();
        var dataSent = JSON.parse(JSON.stringify(this.dataToBeSent))
        idxExe += 1
        dataSent.finajaxparameter = 1
        dataSent.idxExe = idxExe
        if (typeof performance == 'undefined' || typeof performance.memory == 'undefined') {
            dataSent.memoryMo = 0
        } else {
            dataSent.memoryMo = performance.memory.usedJSHeapSize / 1048576
        }

        dataSent.dateDeb = new Date()
        dataSent.dateDebIso = new Date().toISOString()
        if (bddForAjax.positionUser != null) {
            dataSent.latitude = bddForAjax.positionUser.latitude
            dataSent.longitude = bddForAjax.positionUser.longitude
        }
        dataSent.lastDateActiviteUser = lastDateActiviteUser.toISOString()
        //var imgDataScreen = null
        if (dataSent.command != 'verifexistenceimage' && dataSent.command != 'saveuticourantparajson' && dataSent.command != 'getnbemailsmsclickvue' && dataSent.command != 'paraappli' && dataSent.command != 'getnbticketsurappenattente' && dataSent.command != 'traitementbloquantsession') {
            console.log("DEBUT " + dataSent.command + "(" + dataSent.idxExe + ")")
        }
        dataSent.stacktrace = stacktrace

        if (window.tokenFlutter && window.tokenFlutter.length > 0) {
            dataSent.tokencnx = tokenFlutter
            dataSent.iddevicetoken = idDeviceFlutter
            urlCall = "/ext/HandlerFlutter.ashx"
        }

        if (lstAjaxRequestReconnexion.length > 0) {
            //on est en cours de reconnexion
            lstAjaxRequestReconnexion.push(Me)
            return
        }
        return $.ajax({
            type: 'POST',
            url: urlCall,
            async: async,
            timeout: dataSent.timeout,
            data: dataSent,
            success: function (data, status, xhr) {
                lstAjaxRequest.splice(lstAjaxRequest.indexOf(Me), 1)
                if (typeof data.root == 'undefined') {
                    if (typeof parametre != 'undefined' && parametre.isLocalhost) { debugger; alert("bug de démarrage connexion") }

                    var nbHeure = 16
                    if (parametre.isTablette) nbHeure = 720
                    if (log_actuel && (Date.now() - log_actuel.dat.getTime()) / (1000 * 60 * 60) <= nbHeure) {
                        if (lstAjaxRequestReconnexion.length > 0) {
                            if (!lstAjaxRequestReconnexion.contains(Me)) lstAjaxRequestReconnexion.push(Me)
                        } else {
                            lstAjaxRequestReconnexion.push(Me)
                            jaugeDemarrage.mShow()
                            jaugeDemarrage.option("message", "Synchronisation")
                            var startTime = Date.now();
                            if (log_actuel.token) {
                                mConnectWithToken(log_actuel.token, log_actuel.idDevice, log_actuel.version, function (nomBase, theme) {

                                    var traitLstAjaxRequestReconnexion = []
                                    lstAjaxRequestReconnexion.forEach(function (o) { traitLstAjaxRequestReconnexion.push(o) })
                                    lstAjaxRequestReconnexion = []
                                    bddForAjax.mReloadAllTable(function () {
                                        mExeReq()
                                        function mExeReq() {
                                            if (traitLstAjaxRequestReconnexion.length == 0) {
                                                $(window).trigger("reconnexion")
                                                jaugeDemarrage.option("message", null)
                                                jaugeDemarrage.mHide()
                                                let duration = Date.now() - startTime; // en ms
                                                //try {
                                                //    throw new Error("Tentative de reconnexion TOKEN OK1 (" + duration + "ms), connecté depuis " + log_actuel.dat.toDateIlya(true));
                                                //} catch (e) {
                                                //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                                //}
                                                return
                                            } else {
                                                var reqExe = traitLstAjaxRequestReconnexion[0]
                                                traitLstAjaxRequestReconnexion.splice(0, 1)
                                                var funcAlways = reqExe.mGetFuncAlways()
                                                reqExe.mSetFuncAlways(function () {
                                                    if (funcAlways) funcAlways()
                                                    mExeReq()
                                                })
                                                var reqAjaxExe = reqExe.execute()
                                            }
                                        }
                                    })
                                }, function () {
                                    //try {
                                    //    throw new Error("Tentative de reconnexion TOKEN KOOOOO2, connecté depuis " + log_actuel.dat.toDateIlya(true) + "-Redir login");
                                    //} catch (e) {
                                    //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                    //}
                                })
                            } else {
                                mLog(log_actuel.adresse_email, log_actuel.pwd, log_actuel.souvenir, log_actuel.version, null, function () { //ok
                                    var traitLstAjaxRequestReconnexion = []
                                    lstAjaxRequestReconnexion.forEach(function (o) { traitLstAjaxRequestReconnexion.push(o) })
                                    lstAjaxRequestReconnexion = []
                                    bddForAjax.mReloadAllTable(function () {
                                        mExeReq()
                                        function mExeReq() {
                                            if (traitLstAjaxRequestReconnexion.length == 0) {
                                                $(window).trigger("reconnexion")
                                                jaugeDemarrage.option("message", null)
                                                jaugeDemarrage.mHide()
                                                let duration = Date.now() - startTime; // en ms
                                                //try {
                                                //    throw new Error("Tentative de reconnexion OK3 (" + duration + "ms), connecté depuis " + log_actuel.dat.toDateIlya(true));
                                                //} catch (e) {
                                                //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                                //}
                                                return
                                            } else {
                                                var reqExe = traitLstAjaxRequestReconnexion[0]
                                                traitLstAjaxRequestReconnexion.splice(0, 1)
                                                var funcAlways = reqExe.mGetFuncAlways()
                                                reqExe.mSetFuncAlways(function () {
                                                    if (funcAlways) funcAlways()
                                                    mExeReq()
                                                })
                                                var reqAjaxExe = reqExe.execute()
                                            }
                                        }
                                    })
                                }, function () { //KO
                                    //try {
                                    //    throw new Error("Tentative de reconnexion KOOOOO4, connecté depuis " + log_actuel.dat.toDateIlya(true) + "-Redir login");
                                    //} catch (e) {
                                    //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                    //}
                                    jaugeDemarrage.mShow()
                                    window.setTimeout(function () { mRedirectOnLogin(""); }, 500)
                                }, null,true)
                            }
                            return
                        }
                    } else {
                        //try {
                        //    throw new Error("PAS DE reconnexion OUTTTT1, pas de log_actuel" + "-Redir login");
                        //} catch (e) {
                        //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                        //}
                        mRedirectOnLogin("");
                    }
                    return;
                }
                if (typeof data.root.sessionserveurbloque != 'undefined') _SessionServeurBloque = (data.root.sessionserveurbloque == "1")
                switch (data.root.resultat) {
                    case "deconnexion_doublon": mRedirectOnLogin("doubloncnx"); break;
                    case "deconnexion_prisesession": mRedirectOnLogin("prisesession"); break;
                    case "deconnexion_versionchange": mRedirectOnLogin(""); break;
                    case "deconnexion":
                        //on tente de se reconnecter
                        if (log_actuel) {
                            if (lstAjaxRequestReconnexion.length > 0) {
                                //on deja un login en cours
                                if (!lstAjaxRequestReconnexion.contains(Me)) lstAjaxRequestReconnexion.push(Me)
                            } else {
                                lstAjaxRequestReconnexion.push(Me)
                                jaugeDemarrage.mShow()
                                jaugeDemarrage.option("message", "Synchronisation")
                                var startTime = Date.now();
                                if (log_actuel.token) {
                                    var nbHeure = 16
                                    if (parametre.isTablette) nbHeure = 720
                                    if (log_actuel && (Date.now() - log_actuel.dat.getTime()) / (1000 * 60 * 60) > nbHeure) {
                                        //try {
                                        //    throw new Error("Tentative de reconnexion TOKEN KOOOOO5, connecté depuis " + log_actuel.dat.toDateIlya(true) + "-Redir login");
                                        //} catch (e) {
                                        //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                        //}
                                        mRedirectOnLogin("");
                                    } else {
                                        mConnectWithToken(log_actuel.token, log_actuel.idDevice, log_actuel.version, function (nomBase, theme) {
                                            var traitLstAjaxRequestReconnexion = []
                                            lstAjaxRequestReconnexion.forEach(function (o) { traitLstAjaxRequestReconnexion.push(o) })
                                            lstAjaxRequestReconnexion = []
                                            bddForAjax.mReloadAllTable(function () {
                                                mExeReq()
                                                function mExeReq() {
                                                    if (traitLstAjaxRequestReconnexion.length == 0) {
                                                        $(window).trigger("reconnexion")
                                                        jaugeDemarrage.option("message", null)
                                                        jaugeDemarrage.mHide()
                                                        let duration = Date.now() - startTime; // en ms
                                                        //try {
                                                        //    throw new Error("Tentative de reconnexion TOKEN OK6 (" + duration + "ms), connecté depuis " + log_actuel.dat.toDateIlya(true));
                                                        //} catch (e) {
                                                        //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                                        //}
                                                        return
                                                    } else {
                                                        var reqExe = traitLstAjaxRequestReconnexion[0]
                                                        traitLstAjaxRequestReconnexion.splice(0, 1)
                                                        var funcAlways = reqExe.mGetFuncAlways()
                                                        reqExe.mSetFuncAlways(function () {
                                                            if (funcAlways) funcAlways()
                                                            mExeReq()
                                                        })
                                                        var reqAjaxExe = reqExe.execute()
                                                        //reqAjaxExe.always(function () { mExeReq() });
                                                    }
                                                }
                                            })
                                        }, function () {
                                            //try {
                                            //    throw new Error("Tentative de reconnexion TOKEN KOOOOO7, connecté depuis " + log_actuel.dat.toDateIlya(true) + "-Redir login");
                                            //} catch (e) {
                                            //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                            //}
                                        })
                                    }
                                } else {
                                    mLog(log_actuel.adresse_email, log_actuel.pwd, log_actuel.souvenir, log_actuel.version, null, function () { //ok
                                        var traitLstAjaxRequestReconnexion = []
                                        lstAjaxRequestReconnexion.forEach(function (o) { traitLstAjaxRequestReconnexion.push(o) })
                                        lstAjaxRequestReconnexion = []
                                        bddForAjax.mReloadAllTable(function () {
                                            mExeReq()
                                            function mExeReq() {
                                                if (traitLstAjaxRequestReconnexion.length == 0) {
                                                    $(window).trigger("reconnexion")
                                                    jaugeDemarrage.option("message", null)
                                                    jaugeDemarrage.mHide()
                                                    let duration = Date.now() - startTime; // en ms
                                                    //try {
                                                    //    throw new Error("Tentative de reconnexion OK8 (" + duration + "ms), connecté depuis " + log_actuel.dat.toDateIlya(true));
                                                    //} catch (e) {
                                                    //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                                    //}
                                                    return
                                                } else {
                                                    var reqExe = traitLstAjaxRequestReconnexion[0]
                                                    traitLstAjaxRequestReconnexion.splice(0, 1)
                                                    var funcAlways = reqExe.mGetFuncAlways()
                                                    reqExe.mSetFuncAlways(function () {
                                                        if (funcAlways) funcAlways()
                                                        mExeReq()
                                                    })
                                                    var reqAjaxExe = reqExe.execute()
                                                }
                                            }
                                        })
                                    }, function () { //KO
                                        //try {
                                        //    throw new Error("Tentative de reconnexion KOOOOO9, connecté depuis " + log_actuel.dat.toDateIlya(true) + "-Redir login");
                                        //} catch (e) {
                                        //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                                        //}
                                        jaugeDemarrage.mShow()
                                        window.setTimeout(function () { mRedirectOnLogin(""); }, 500)
                                    }, null,true)
                                }
                            }

                        } else {
                            //try {
                            //    throw new Error("PAS DE reconnexion OUTTTT2, pas de log_actuel" + "-Redir login");
                            //} catch (e) {
                            //    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                            //}
                            mRedirectOnLogin("");
                        }
                        //mRedirectOnLogin("");
                        break;
                    case "acces_interdit":
                        mNotify("Impossible d'accéder au traitement demandé.", "warning", 6000)
                        if (funcKo) funcKo(data);
                        break;
                    case "ko":
                        if (window.nbShootingLog < 5 && (window.lastDateShootingLog == null || ((new Date()) - window.lastDateShootingLog) > 5000) &&
                            typeof data.root.id_log != 'undefined' && data.root.id_log != null) {
                            //on une erreur avec un log
                            mCapturerPageImage(function (imgData) {
                                if (imgData.length > 0) {
                                    var urlHandler = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
                                    var dataToBeSent = {
                                        command: "writeimagdatascreenlog",
                                        id_log: data.root.id_log,
                                        img_data_screen: imgData
                                    };
                                    $.post(urlHandler, dataToBeSent, function (data) { }, 'json')
                                        .fail(function (data) { })
                                        .always(function (data) { });
                                }
                            }, true)
                        }
                        if (funcKo) { funcKo(data); }
                        else {
                            mNotify("Une erreur est survenue sur le serveur. Impossible de faire le traitement demandé.", "warning", 6000)
                            if (!hasTraitementBloquantEnCours) {
                                $("body").find(".dx-ctrljauge").each(function () {
                                    var jauge = $(this).getInstance()
                                    jauge.mHide();
                                })
                            }
                        }
                        break;
                    case "ok":
                        if (dataSent.command != 'verifexistenceimage' && dataSent.command != 'saveuticourantparajson' && dataSent.command != 'getnbemailsmsclickvue' && dataSent.command != 'paraappli' && dataSent.command != 'getnbticketsurappenattente') console.log("FIN CALL SERVEUR " + dataSent.command + "(" + dataSent.idxExe + ") " + diffdate(dataSent.dateDeb, new Date(), "ms") + "ms")
                        Me.mTraiteRetourAjaxSuccessOk(data)

                        if (typeof data.root.id_log_handler_loaddatagrid != "undefined") {
                            var dataForLog = {
                                command: "saveloghandlerloaddatagrid",
                                date_fin_iso: (new Date()).toISOString(),
                                ms: diffdate(dataSent.dateDeb, new Date(), "ms"),
                                id_log_handler_loaddatagrid: data.root.id_log_handler_loaddatagrid
                            }
                            if (window.tokenFlutter && window.tokenFlutter.length > 0) {
                                dataForLog.tokencnx = tokenFlutter
                                dataForLog.iddevicetoken = idDeviceFlutter
                                dataForLog.nom_base = nom_base_demarrage
                            }
                            $.ajax({
                                type: 'POST',
                                url: urlCall,
                                async: true,
                                data: dataForLog
                            })
                        }
                        break;
                }
                if (dataSent.command != 'verifexistenceimage' && dataSent.command != 'saveuticourantparajson' && dataSent.command != 'getnbemailsmsclickvue' && dataSent.command != 'paraappli' && dataSent.command != 'getnbticketsurappenattente') console.log("FIN " + dataSent.command + "(" + dataSent.idxExe + ") " + diffdate(dataSent.dateDeb, new Date(), "ms") + "ms")
            },
            complete: function (xhr, status) {
                lstAjaxRequest.splice(lstAjaxRequest.indexOf(Me), 1)
                if (funcAlways) funcAlways(xhr);
            },
            error: function (xhr, status, error) {
                if (!navigator.onLine) {
                    mNotify("Impossible de se connecter au serveur. Vérifier votre connexion internet.", "error", 6000)
                    $("body").find(".dx-ctrljauge").each(function () {
                        var jauge = $(this).getInstance()
                        jauge.mHide();
                    })
                    return
                }
                if (error == "abort") { }
                else if (error == "Service Unavailable") {
                    mRedirectOnLogin("");
                } else {
                    if (typeof xhr.responseText == 'undefined') {
                        if (typeof parametre != 'undefined' && parametre.isLocalhost) {
                            console.log("Erreur debug sur command " + dataSent.command)
                            if (funcKo) funcKo({
                                xhr: xhr,
                                status: status,
                                error: error
                            });
                        } else {
                            lstAjaxRequestAbort.push(Me);
                        }
                    } else {
                        console.log(xhr.responseText)
                        if (funcKo) {
                            funcKo({
                                xhr: xhr,
                                status: status,
                                error: error
                            });
                        } else {
                            if (typeof showErreur == 'undefined' || showErreur) {
                                if (xhr.status != '500') mNotify("Une erreur est survenue sur le serveur. Impossible de faire le traitement demandé.", "warning", 6000)
                                //if (parametre.isLocalhost) {
                                //    debugger;
                                //}
                            }
                            if (!hasTraitementBloquantEnCours) {
                                $("body").find(".dx-ctrljauge").each(function () {
                                    var jauge = $(this).getInstance()
                                    jauge.mHide();
                                })
                            }
                        }
                    }
                }

            }
        })
    }

    this.mTraiteRetourAjaxSuccessOk = function (data) {
        if (typeof data.root.init_data_demarrage != 'undefined') {
            if (typeof data.root.init_data_demarrage.uticnx == 'undefined') {
                bddForAjax.utiCnx = null
            } else {
                bddForAjax.utiCnx = JSON.parse(data.root.init_data_demarrage.uticnx).root
                bddForAjax.utiCnx.isAuthentified = ((bddForAjax.utiCnx.isAuthentified == "1"))
                bddForAjax.utiCnx.isFromGest = ((bddForAjax.utiCnx.isFromGest == "1"))
            }
            bddForAjax.tarif = JSON.parse(data.root.init_data_demarrage.tarif).tarif
            bddForAjax.schemaBdd = JSON.parse(data.root.init_data_demarrage.schemabdd).schemabdd
            bddForAjax.utiCourant = { id_utilisateur: data.root.init_data_demarrage.id_utilisateur_courant }
            //if (JSON.parse(data.root.init_data_demarrage.uticnx).root.id_utilisateur == 99998) {
            //    //dans le cas d'une connexion avec externe, on se retrouve avec le robot sur //data.root.init_data_demarrage.id_utilisateur_courant
            //    //on force l'externe
            //    bddForAjax.utiCourant = { id_utilisateur: 99998 }
            //}
            mClearArrayFromJson(bddForAjax.schemaBdd)
            bddForAjax.vue_table = JSON.parse(data.root.init_data_demarrage.vue_table).root.vue_table
            bddForAjax.vue_colonne = JSON.parse(data.root.init_data_demarrage.vue_colonne).root.vue_colonne
        }
        if (typeof parametre != 'undefined' && typeof data.root.dateNow != 'undefined') {
            parametre.dateNow = (data.root.dateNow instanceof Date ? data.root.dateNow : data.root.dateNow.toDate())
        }
        mClearArrayFromJson(data);
        if (typeof Me.dataToBeSent.notMigreDate == 'undefined') mMigreFormatDateFromJsonCalcul(data);
        if (typeof data.root.temps_deploiement_restant != "undefined" && typeof page != 'undefined' && page) mShowAlertDeploiement(data.root.temps_deploiement_restant, bddForAjax);
        if (bddForAjax) bddForAjax.mMaj(data.root.bdd)
        if (bddForAjax) bddForAjax.mAddOrMajData(data.root.bddupdate)
        if (bddForAjax && typeof data.root.bddadd != 'undefined') bddForAjax.mAddData(data.root.bddadd)
        if (bddForAjax && typeof data.root.bddmaj != 'undefined') bddForAjax.mMajData(data.root.bddmaj)
        if (bddForAjax && typeof data.root.bddremove != 'undefined') bddForAjax.mRemoveData(data.root.bddremove)

        if (funcOk) funcOk(data.root);
    }

    this.executeInTest = function (funcAllwaysTest, funcFail) {
        var urlCall = this.url + ((this.url.contains("?")) ? '&' : '?') + 'timestamp=' + new Date().getTime()

        _lastDateRequestAjax = new Date();
        return $.ajax({
            type: 'POST',
            url: urlCall,
            async: async,
            data: this.dataToBeSent,
            success: function (data, status, xhr) {
                lstAjaxRequestAbort.splice(lstAjaxRequestAbort.indexOf(Me), 1)
                if (lstAjaxRequestAbort.length == 0) {
                } else { lstAjaxRequestAbort[0].executeInTest(); }
                if (typeof data.root == 'undefined') { mRedirectOnLogin("prisesession"); }
                else {
                    if (typeof data.root.sessionserveurbloque != 'undefined') _SessionServeurBloque = (data.root.sessionserveurbloque == "1")
                    switch (data.root.resultat) {
                        case "deconnexion_prisesession": mRedirectOnLogin("prisesession"); break;
                        case "deconnexion_doublon": mRedirectOnLogin("doubloncnx"); break;
                        case "deconnexion": mRedirectOnLogin(false, false, false); break;
                        case "ko": if (funcKo) funcKo(); break;
                        case "ok":
                            mClearArrayFromJson(data);
                            mMigreFormatDateFromJsonCalcul(data);
                            if (typeof data.root.temps_deploiement_restant != "undefined" && typeof page != 'undefined' && page) mShowAlertDeploiement(data.root.temps_deploiement_restant, bddForAjax);
                            if (bddForAjax) bddForAjax.mMaj(data.root.bdd)
                            if (bddForAjax && typeof data.root.bddadd != 'undefined') bddForAjax.mAddData(data.root.bddadd)
                            if (funcOk) funcOk(data.root);
                            break;
                    }
                }
            },
            complete: function (xhr, status) {
                if (funcAllwaysTest) funcAllwaysTest();
                if (funcAlways) funcAlways();
            },
            error: function (xhr, status, error) {
                if (funcFail) funcFail();
            }
        })
    }

}

window.mRedirectOnLogin = function (typDeconnect, dataErreurServeur) {
    debugger;
    forcerFermetureNavigateur = true;
    if (typeof typDeconnect == 'undefined' || typDeconnect == null) typDeconnect = ""
    if (jaugeDemarrage) {
        jaugeDemarrage.option("message", null)
        jaugeDemarrage.option("onCancel", null)
        jaugeDemarrage.mShow(0)
    }
    if (dataErreurServeur) {
        // Charger la string comme un objet jQuery
        let texte = $(dataErreurServeur).text();
        // Nettoyer les espaces multiples
        texte = texte.replace(/\s+/g, ' ').trim();
        try {
            mTraiteMessageJs("erreurjsgrave", "Erreur sur serveur suite appel AJAX (reboot bdd) /n" + texte + "/n" + mGetStackTrace(), document.URLRacine, 0, null, null, "red", function () {
                var dataToBeSent = {
                    command: "rebootbdd"
                }
                var url = "/handler/handlerinterne.ashx?d=" + (new Date()).getTime()
                if (window.tokenFlutter && window.tokenFlutter.length > 0) {
                    dataToBeSent.tokencnx = tokenFlutter
                    dataToBeSent.iddevicetoken = idDeviceFlutter
                    url = "/ext/HandlerFlutter.ashx?d=" + (new Date()).getTime()
                }
                return $.ajax({
                    type: 'POST',
                    url: url,
                    async: true,
                    data: dataToBeSent,
                    success: function (data, status, xhr) {

                    },
                    complete: function (xhr, status) {
                        mRedirectOnLogin(typDeconnect)
                    },
                    error: function (xhr, status, error) {
                        if (funcFail) funcFail();
                    }
                })
            })
        }
        catch (e) {
            debugger;
            mRedirectOnLogin(typDeconnect)
        }
    } else {
        window.setTimeout(function () {
            var txtPara = ""
            if (typDeconnect.startsWith("redirect")) {
                txtPara += ((txtPara.length > 0) ? "&" : "") + "redirectdomaine=" + typDeconnect.split("|")[1];
            } else {
                switch (typDeconnect) {
                    case "prisesession": txtPara += ((txtPara.length > 0) ? "&" : "") + "prisesession=1"; break;
                    case "doubloncnx": txtPara += ((txtPara.length > 0) ? "&" : "") + "doubloncnx=1"; break;
                    case "deconnexionManuel": txtPara += ((txtPara.length > 0) ? "&" : "") + "deconnectmanuel=1"; break;
                    case "livraison": txtPara += ((txtPara.length > 0) ? "&" : "") + "livraison=1"; break;
                }
            }

            //if (priseSession) txtPara += ((txtPara.length > 0) ? "&" : "") + "prisesession=1"
            //if (doublonCnx) txtPara += ((txtPara.length > 0) ? "&" : "") + "doubloncnx=1"
            //if (deconnexionManuel) txtPara += ((txtPara.length > 0) ? "&" : "") + "deconnectmanuel=1"
            if (txtPara.length > 0) txtPara = "?" + txtPara
            window.open("/l/logoutclient.aspx" + txtPara, "_self");
        }, 500)
    }
}